enum DataViewDisplayType {
  PERCENTAGE,
  GROSS,
}

export default DataViewDisplayType;
